import { ICSSInJSStyle } from "@fluentui/react-northstar";

export const fluentProviderStyles: ICSSInJSStyle = {
  flexGrow: 1, // Required to provide full flex property to support IE11
  display: "flex",
  flexDirection: "column",
  maxHeight: "100%",
  overflow: "hidden",
  "& a": {
    textDecoration: "none",
  },
};
